'use strict';

var container = require('skygear-core');
var forgotPassword = require('skygear-forgot-password');
var sso = require('skygear-sso');

forgotPassword.injectToContainer(container);
sso.injectToContainer(container);

module.exports = container;


//////////////////
// WEBPACK FOOTER
// ./~/skygear/dist/index.js
// module id = 288
// module chunks = 0